export const NavProfileIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="5" r="4.25" fill="white" stroke="black" strokeWidth="1.5" />
      <path
        d="M11.667 14.75H18.333C24.3621 14.75 29.25 19.6379 29.25 25.667C29.2498 26.5412 28.5412 27.2498 27.667 27.25H2.33301C1.45882 27.2498 0.750176 26.5412 0.75 25.667C0.75 19.6379 5.63788 14.75 11.667 14.75Z"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
};
